import React from "react";
import PropTypes from "prop-types";

import colors from "core/colors";
import BodyText from "core/BodyText";
import Link from "core/Link";
import { AttributionRequiredStyled, DigitalUseStyled } from "./styles";

const AttrReqMessageForModal = ({ attrMessages }) => {
    return (
        <>
            <BodyText size="lg" copyColor={colors.secondary.oolong}>
                <AttributionRequiredStyled>
                    {attrMessages.map((attrMessage, idx) => {
                        return (
                            <span key={idx}>
                                {attrMessage.text}{" "}
                                <Link href={attrMessage.href} target="_blank">
                                    {attrMessage.linkText}
                                </Link>
                                .{" "}
                            </span>
                        );
                    })}
                </AttributionRequiredStyled>
                <DigitalUseStyled>
                    Insert link below for digital uses.
                </DigitalUseStyled>
            </BodyText>
        </>
    );
};

export default AttrReqMessageForModal;

// prop-types
AttrReqMessageForModal.propTypes = {
    attrMessages: PropTypes.array
};
